import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { _axios as axios, cancelToken, customFetch } from '../utils/auth';
import { url as API_URL } from '../utils';
import { RootState } from '.';
import { stat } from 'fs';

export interface Action {
  id: number;
  nameTH: string;
  nameCN: string;
  nameEN: string;
}

export interface Category {
  id: number | null;
  nameTH: string;
  nameCN: string;
  nameEN: string;
}

export interface LocationType {
  id: number | null;
  nameTH: string;
  nameCN: string;
  nameEN: string;
}

export interface Location {
  a: string;
}

interface State {
  actions: Action[] | null;
  categories: Category[] | null;
  locationTypes: LocationType[] | null;
}

const initialState: State = {
  actions: null,
  categories: null,
  locationTypes: null,
};

export const getActions = createAsyncThunk<Action[]>('actions/getActions', async () => {
  const response = await axios.get(`${API_URL}/v1/actions/buyers`);

  return response.data.data;
});

export const getCategories = createAsyncThunk<Category[]>('actions/getCategories', async () => {
  const response = await axios.get(`${API_URL}/v1/category`);

  return response.data.data;
});

export const getLocationTypes = createAsyncThunk<LocationType[]>('actions/getLocationTypes', async () => {
  const response = await axios.get(`${API_URL}/v1/location_type`);

  return response.data.data;
});

export const buyerSlice = createSlice({
  name: 'buyer',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getActions.fulfilled, (state, action) => {
        state.actions = action.payload;
      })
      .addCase(getCategories.fulfilled, (state, action) => {
        state.categories = action.payload;
      })
      .addCase(getLocationTypes.fulfilled, (state, action) => {
        state.locationTypes = action.payload;
      });
  },
});

export const buyerReducer = buyerSlice.reducer;

export const selectActions = (state: RootState) => state.buyer.actions;
export const selectCategories = (state: RootState) => state.buyer.categories;
export const selectLocationTypes = (state: RootState) => state.buyer.locationTypes;
